import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    iconContent: {
        justifyContent: "center",
        alignItems: "center",
        height: 50,
        width: 50
    },
    headerTitleContainer: {
        position: "absolute",
        alignItems: "center",
        right: 0,
        left: 0
    },
    loadingContainer: {
        justifyContent: "center",
        alignItems: "center"
    },
    policyCardDateContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    headerContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    policyCardContent: {
        justifyContent: "center"
    },
    contentContainer: {
        alignItems: "flex-start"
    },
    backButton: {
        alignSelf: "flex-start"
    },
    policyCard: {
        flexDirection: "row"
    },
    headerTitle: {
        textAlign: "center"
    },
    container: {
        paddingTop: 0
    },
    dot: {
        height: 2,
        width: 2
    },
    scrollView: {
        flex: 1
    },
    markdownContainer: {}
});
export default stylesheet;
